import { z } from "zod";

/** A device: the public half of its Ed25519 key, as base64url. Every request is signed with it. */
export const DeviceKey = z.string().regex(/^[A-Za-z0-9_-]{43}$/, "That's not a device's key.");

/** The id of an account, group, band or setlist: a random UUID. */
export const Id = z.uuid();
